import {unitTypeKeys} from "./constants";

/**
 * The tabs inside a property page: the building information, the shops of a shopping mall and a list per unit type.
 * They are addressed by key, a unit list by its unit type. Not to be confused with the widget tabs, see tabs.ts.
 */
export const BUILDING_INFO_TAB = 'building_info'
export const SHOPS_TAB = 'shops'

export type UnitListTab = {
  unitType: unitTypeKeys;
  // key in the translation dictionaries
  labelKey: string;
}

// in the order of the tab bar
export const UNIT_LIST_TABS: UnitListTab[] = [
  {unitType: unitTypeKeys.hotelRoomType, labelKey: 'tabTitle_hospitalityRooms'},
  {unitType: unitTypeKeys.meetingRoom, labelKey: 'tabTitle_meetingRooms'},
  {unitType: unitTypeKeys.exhibition, labelKey: 'exhibition'},
  {unitType: unitTypeKeys.museumShop, labelKey: 'shop'},
  {unitType: unitTypeKeys.attraction, labelKey: 'attractions'},
  {unitType: unitTypeKeys.restaurant, labelKey: 'restaurant'},
  {unitType: unitTypeKeys.mannedKiosk, labelKey: 'kiosk'},
  {unitType: unitTypeKeys.toiletRoomCommon, labelKey: 'bathrooms'},
]

export type PropertyPageTabKey = typeof BUILDING_INFO_TAB | typeof SHOPS_TAB | unitTypeKeys

export const getUnitListTab = (key: PropertyPageTabKey): UnitListTab | undefined => (
  UNIT_LIST_TABS.find((tab) => tab.unitType === key)
)
